import { nodesFlux } from '@candulabs/craft';
import React, { useMemo } from 'react';

import { toCssSelector } from '@candu-ai/stylesheet/utils';
import Node from 'craft/components/Node';
import { TextAlignmentButtons } from 'craft/components/SelectedToolbar';
import { BuiltInComponents, richTextEditorDescendants } from 'craft/constants';
import { useEditorSelector, useNodeContext } from 'craft/hooks';
import { Resolver } from 'craft/types';

import { ListSettings, ListStyles } from './toolbox';

export const List: Resolver = (props: any) => {
  const { id: nodeId } = useNodeContext();
  const customSelector = useMemo(() => nodesFlux.selectors.getNodeCustom(nodeId), [nodeId]);
  const { variant = 'UL' } = useEditorSelector(customSelector).custom ?? {};

  const typographySelector = toCssSelector('list', {
    variant: { variant },
    output: 'html',
  });
  const propsWithVariant = {
    ...props,
    className: `${props.className || ''} ${typographySelector}`,
  };

  return <Node id={nodeId} is={variant} {...propsWithVariant} />;
};

List.craft = {
  name: BuiltInComponents.List,
  isCanvas: true,
  rules: {
    canMoveIn: (incomingNodes) =>
      incomingNodes.every((node) =>
        richTextEditorDescendants.includes(node.data.name as BuiltInComponents),
      ),
  },
};

List.slate = {
  toCraftNode: (slateNode: any) => (craftNode: any) => {
    // Note: if slate node is created by normalization logic
    // it might not have data
    // TODO look into this to determine if it causes problems
    // eslint-disable-next-line
    craftNode.data.custom = {
      ...craftNode.data.custom,
      css: slateNode.data?.css,
      custom: {
        ...(craftNode.data?.custom?.custom ?? {}),
        variant: slateNode.data?.variant || 'UL',
      },
    };
  },
  toSlateNode: (craftNode: any) => (slateNode: any) => {
    // eslint-disable-next-line
    slateNode.data = {
      variant: craftNode.data.custom.custom?.variant || 'UL',
      css: craftNode.data.custom.css || {
        paddingLeft: '40px',
        marginBottom: '16px',
      },
    };
  },
};

List.toolbox = {
  component: [ListSettings, ListStyles],
};

List.selectedToolbar = {
  customItems: [TextAlignmentButtons],
};
